import {postRequest, postRequestFile} from "../../utils/api"

export const importExamQuestion = (params) => {
    return postRequestFile('/core/examQuestion/importExamQuestion',params)
}